const canAccessVerification = ({ features, entitlement }) =>
  features.includes("knowledge_bank_verification") &&
  ["admin", "manager"].includes(entitlement);

export default canAccessVerification;



// WEBPACK FOOTER //
// ./src/utils/canAccessVerification.js